'use client';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { Modal } from '@depop/web-ui-kit/Modal';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ShopSummaryActionsCta } from '@/app/[locale]/products/[slug]/components/ShopSummaryActions/ShopSummaryActionsCta';
import { useSellerActions } from '@/app/[locale]/products/[slug]/hooks/useSellerActions';
import { ButtonExperiment } from '@/components/ButtonExperiment';
import { DownloadAppModal } from '@/components/DownloadAppModal/DownloadAppModal.tsx';

export function ShopSummaryActions() {
  const t = useTranslations('product');
  const {
    isSuccess,
    isAuthenticated,
    shopHref,
    messagesUrl,
    handleVisitShopClick,
    handleMessageClick,
    isDownloadAppModalOpen,
    setIsDownloadAppModalOpen,
  } = useSellerActions();

  const buttonProps = {
    fullWidth: true,
    variant: 'secondary',
    legacyClassName: styles.button,
  } as const;

  return (
    <div className={styles.container}>
      <ShopSummaryActionsCta
        {...buttonProps}
        href={isSuccess ? shopHref : undefined}
        onClick={handleVisitShopClick}
      >
        <Caption as="span" colour="base" variant="lg-regular">
          {t('SellerCta.Shop')}
        </Caption>
      </ShopSummaryActionsCta>
      {isAuthenticated ? (
        <ShopSummaryActionsCta
          {...buttonProps}
          href={isSuccess ? messagesUrl : undefined}
          onClick={handleMessageClick}
        >
          <Caption as="span" colour="base" variant="lg-regular">
            {t('SellerCta.Question')}
          </Caption>
        </ShopSummaryActionsCta>
      ) : (
        <>
          <ButtonExperiment
            {...buttonProps}
            onClick={handleMessageClick}
            disabled={!isSuccess}
          >
            <Caption as="span" colour="base" variant="lg-regular">
              {t('SellerCta.Question')}
            </Caption>
          </ButtonExperiment>
          <Modal
            isOpen={isDownloadAppModalOpen}
            setOpen={setIsDownloadAppModalOpen}
            content={() => (
              <DownloadAppModal downloadAppTrackingId="pdp_shop_summary" />
            )}
          />
        </>
      )}
    </div>
  );
}
